import { useEffect, useRef } from 'react';

const useShowWarning = (message = 'Are you sure you want to leave') => {
    const shouldBlockRef = useRef(false);

    useEffect(() => {
        window.onbeforeunload = () => {
            if (shouldBlockRef.current) return message;
        };
        return () => {
            window.onbeforeunload = null;
        };
    }, [message]);

    const setDirty = () => (shouldBlockRef.current = true);
    const setPristine = () => (shouldBlockRef.current = false);

    return {
        setDirty,
        setPristine
    };
};

export default useShowWarning;
